import { GET_MINI_CART_DETAILS } from './types';


export const miniCartDetailsAction = (miniCartDetails) => dispatch => {
    console.log('miniCartDetails..in redux..',miniCartDetails);
    dispatch({
        type: GET_MINI_CART_DETAILS,
        miniCartDetails : miniCartDetails,
    })

}
